import { ly } from "../../../i18n/en";


export default {
    introduction: [
        { text: "Xiamen Square is located at No. 2 " },
        { text: "Lujiang Road, Siming District. The" },
        { text: "total construction area of the " },
        { text: "project is approximately 53000, " },
        { text: "with a total height of 137 meters." },
        { text: "There are 201 parking spaces on " },
        { text: "the three underground floors. " },
        { text: "There are a total of 37 floors " },
        { text: "above ground, with the first floor " },
        { text: "serving as a luxurious 12 meter " },
        { text: "high lobby, including a coffee shop, " },
        { text: "the second floor serving as the " },
        { text: "exclusive cafeteria of the building, " },
        { text: "the 11th floor serving as an aerial " },
        { text: "garden and administrative lounge, " },
        { text: "the 12th to 15th floors serving as " },
        { text: "multi-functional meetings, and the " },
        { text: "31st to 37th floors serving as self " },
        { text: "use and cooperative enterprises of " },
        { text: "the group. The remaining floors are " },
        { text: "part of the office building for " },
        { text: "external leasing, and the project " },
        { text: "has been put into use." },
    ],

    buildingIndex: {
        airQuality: '良好',
        peopleOutIn: '234/34',
        ele: '3232',
        water: '343'
    },
    peopleOutIn: {
        time: ['08:00', '08:10', '08:20', '08:30', '08:40', '08:50', '09:00', '09:10'],
        name: [ly.$ly_l2_name1, ly.$ly_l2_name2],
        out: [21, 32, 54, 23, 43, 43, 32, 50],
        in: [4, 13, 14, 15, 18, 13, 8, 3]
    },
    energy: {
        energyRatio: 89,
        totalEnergy: 54329,
        totalLoad: 4356.4
    },
    people: {
        staff: 1664,
        security: 670,
        visitor: 854,
    },
    flowAnalysis: {
        staff: 1200,
        flow: 1543
    },
    flowYearAnalysis: {
        time: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        '2020': [123, 234, 843, 754, 534, 435, 676, 893, 923, 605, 504, 343],
        '2021': [167, 314, 883, 794, 624, 555, 716, 953, 1093, 735, 634, 413],
    },
    regionLease: {
        'A区': {
            useArea: 1534,
            rentArea: 2478,
            rentedArea: 1244,
            notRentedArea: 1234
        },
        'B区': {
            useArea: 1234,
            rentArea: 1244,
            rentedArea: 1244,
            notRentedArea: 1234
        },
        'C区': {
            useArea: 1234,
            rentArea: 1244,
            rentedArea: 1244,
            notRentedArea: 1234
        }
    },
    enterprise: [
        {
            "name": "Hightopo",
            "bgVisible": true,
            "legalPerson": "林*",
            "peopleNumber": "150 人",
            "area": "2500 m³"
        },
        {
            "name": "厦门图扑软件",
            "bgVisible": false,
            "legalPerson": "林*",
            "peopleNumber": "150 人",
            "area": "2500 m³"
        },
        {
            "name": "上海图扑软件",
            "bgVisible": true,
            "legalPerson": "林*",
            "peopleNumber": "150 人",
            "area": "2500 m³"
        },
        {
            "name": "天津图扑软件",
            "bgVisible": false,
            "legalPerson": "李*",
            "peopleNumber": "150 人",
            "area": "2500 m³"
        },
        {
            "name": "青岛图扑软件",
            "bgVisible": true,
            "legalPerson": "于*",
            "peopleNumber": "150 人",
            "area": "2500 m³"
        },
        {
            "name": "大连图扑软件",
            "bgVisible": false,
            "legalPerson": "薄*",
            "peopleNumber": "150 人",
            "area": "2500 m³"
        },
        {
            "name": "成都图扑软件",
            "bgVisible": true,
            "legalPerson": "郑*",
            "peopleNumber": "150 人",
            "area": "2500 m³"
        },
        {
            "name": "北京图扑软件",
            "bgVisible": false,
            "legalPerson": "林*",
            "peopleNumber": "150 人",
            "area": "2500 m³"
        }
    ],
    leaseArea: {
        area: [3234, 2355, 1233],
        time: ['一月', '二月', '三月', '四月', '五月', '六月'],
        useArea: [50, 60, 60, 71, 65, 58],
        rentedArea: [120, 134, 156, 161, 144, 134],
        notRentedArea: [263, 254, 216, 181, 174, 154],
    },
    prices: {
        region: [1900, 1500, 1200],
        A: {
            'A01': 2100,
            'A02': 2050,
            'A03': 1910,
            'A04': 1800,
            'A05': 1850,
            'A06': 1920
        },
        B: {
            'B01': 2100,
            'B02': 2050,
            'B03': 1910,
            'B04': 1800,
            'B05': 1850,
            'B06': 1920,
            'B07': 1800,
            'B08': 1850,
            'B09': 1920,
            'B10': 1850,
            'B11': 1920
        },
        C: {
            'C01': 2100,
            'C02': 2050,
            'C03': 1910,
            'C04': 1800,
            'C05': 1850,
            'C06': 1920,
            'C07': 1910,
            'C08': 1800,
        }
    },
    pageLight: {
        environment: [
            {
                "region": "1A-1B waiting area",
                "sensor": "1-1",
                "value": 280
            },
            {
                "region": "1A-2B waiting area",
                "sensor": "1-2",
                "value": 430
            },
            {
                "region": "2A-1B waiting area",
                "sensor": "2-1",
                "value": 334
            },
            {
                "region": "1A-10B waiting area",
                "sensor": "1-10",
                "value": 210
            },
            {
                "region": "4A-1B waiting area",
                "sensor": "4-1",
                "value": 452
            },
            {
                "region": "4A-2B waiting area",
                "sensor": "4-2",
                "value": 533
            },
            {
                "region": "4A-3B waiting area",
                "sensor": "4-3",
                "value": 283
            },
            {
                "region": "1A-5B waiting area",
                "sensor": "1-5",
                "value": 432
            }
        ],
        lighting: [
            "Mon",
            "Tues",
            "Wed",
            "Thur",
            "Fri",
            "Sat",
            "Sun"
        ],
        alarm: [
            {
                "level": "一级",
                "levelText": "Level 1",
                "time": "2021-04-29 12:25",
                "content": "Sensor syl alarm",
                "content2": "Need to shut down"
            },
            {
                "level": "二级",
                "levelText": "Level 2",
                "time": "2021-04-29 12:25",
                "content": "Sensor syl alarm",
                "content2": "Need to shut down"
            },
            {
                "level": "二级",
                "levelText": "Level 2",
                "time": "2021-04-29 12:25",
                "content": "Sensor syl alarm",
                "content2": "Need to shut down"
            },
            {
                "level": "一级",
                "levelText": "Level 1",
                "time": "2021-04-29 12:25",
                "content": "Sensor syl alarm",
                "content2": "Need to shut down"
            },
            {
                "level": "二级",
                "levelText": "Level 2",
                "time": "2021-04-29 12:25",
                "content": "Sensor syl alarm",
                "content2": "Need to shut down"
            }
        ]
    },

    pageFire: {
        highRiskFire: [
            {
                "level": "Fire Alarm",
                "time": "2021-04-29 12:25",
                "content": "Elevator：010070 point type smoke sensing"
            },
            {
                "level": "Fire Alarm",
                "time": "2021-04-29 12:25",
                "content": "Elevator：010070 point type smoke sensing"
            },
            {
                "level": "Fire",
                "time": "2021-04-29 12:25",
                "content": "Elevator：010070 point type smoke sensing"
            },
            {
                "level": "Fire Alarm",
                "time": "2021-04-29 12:25",
                "content": "Elevator：010070 point type smoke sensing"
            },
            {
                "level": "Fire",
                "time": "2021-04-29 12:25",
                "content": "Elevator：010070 point type smoke sensing"
            },
            {
                "level": "Fire Alarm",
                "time": "2021-04-29 12:25",
                "content": "Elevator：010070 point type smoke sensing"
            },
            {
                "level": "Fire",
                "time": "2021-04-29 12:25",
                "content": "Elevator：010070 point type smoke sensing"
            }
        ]
    }
};

